import { Badge, Card, FontIcon, Typography } from "@ezmid/components-library";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { EntityPayment } from "../../../api/payments.generated";

const DEFAULT_IMAGE = "/avatar.svg";
type Props = {
  currentData?: EntityPayment;
};

export function UserPaymentCard({ currentData }: Props) {
  const { t } = useTranslation();
  const userImage = currentData?.user?.image?.image?.content?.find(
    ({ type }) => type === "square-small"
  )?.url;
  const isActive = currentData?.user?.status === "us-active";
  const badgeStatusVariant = isActive ? "success" : "danger";
  const notificationsBadgeLabel = currentData?.user?.sendNotifications
    ? t("button.yes")
    : t("button.no");

  return (
    <Card
      shadows="xl"
      size="lg"
      margin={2}
      hasBorder={false}
      headerText={t("user.informations")}
      headerIcon={
        <FontIcon
          marginTop={4}
          customIcon={<FontAwesomeIcon size="lg" icon={faInfoCircle} />}
        />
      }
    >
      <div className="p-4">
        <div className="flex items-center mb-4">
          <img
            className="w-12 h-12 rounded-full mr-4"
            src={userImage || DEFAULT_IMAGE}
            alt="User Avatar"
          />
          <div>
            <p className="font-bold text-lg">{currentData?.user?.name}</p>
            <p className="text-gray-500">{currentData?.user?.email}</p>
          </div>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t("payment.name")}:`}</p>
          <Typography variant="body1">{currentData?.user?.name}</Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t("payment.email")}:`}</p>
          <Typography variant="body1">{currentData?.user?.email}</Typography>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t("payment.role")}:`}</p>
          <Badge variant="pill">{currentData?.user?.role}</Badge>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t("payment.status")}:`}</p>
          <Badge className="pl-2" variant="pill" status={badgeStatusVariant}>
            {currentData?.user?.status}
          </Badge>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t("payment.user.origin")}:`}</p>
          <Badge variant="pill">{currentData?.user?.userOrigin}</Badge>
        </div>
        <div className="flex items-center mb-2">
          <p className="font-bold mr-2">{`${t(
            "payment.send.notifications"
          )}:`}</p>
          <Badge variant="pill">{notificationsBadgeLabel}</Badge>
        </div>
      </div>
    </Card>
  );
}
